import React from 'react';
import App from './App';

import {Provider} from "react-redux";
import axios from "axios";
import {gconf} from "conf/gconf";
import {configureStore} from '@reduxjs/toolkit';
import reducers from "store/reducers";
import {setstore} from "store/ssqstore";
import {initsvrconf} from "conf/svrconf";
import svcs from "services";
import "index.css";
import {ssqutil} from "util/ssqutil";

import "util/axiosutil";
import {createRoot} from 'react-dom/client';
import {paxios} from 'util/axiosprgs';

// const enhancer =
//     process.env.NODE_ENV === "production"
//         ? compose(applyMiddleware())
//         : composeWithDevTools(applyMiddleware(logger));

// const store = createStore(rootReducer, enhancer)
//const store = createStore(rootReducer, composeWithDevTools());

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
    immutableCheck: false,
  }),
  devTools: !ssqutil.isProduction()
});

setstore(store);

const container = document.getElementById('app');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<Provider store={store}>
  <React.StrictMode>
    <App/>
  </React.StrictMode>
</Provider>);

(window as any).axios = axios;
(window as any).gconf = gconf;
(window as any).svcs = svcs;
(window as any).paxios = paxios;

initsvrconf();

export default App;